export default function EditCustomer() {
  return (
    <div>EditCustomer</div>
  )
}
